import { Button, PortalErrorPage, PortalIcon } from '@ignite/ui';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

function HomeButton({ variant = 'default' }: { variant?: 'default' | 'outline' }) {
  const { t } = useTranslation();

  return (
    <Button nativeButton={false} render={<Link to="/" />} size="default" variant={variant}>
      {t('admin.error.actions.home')}
    </Button>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <PortalErrorPage
      actions={<HomeButton />}
      brand={t('admin.error.brand')}
      description={t('admin.error.notFound.description')}
      status="not-found"
      title={t('admin.error.notFound.title')}
    />
  );
}

export function RouteErrorPage() {
  const { t } = useTranslation();

  return (
    <PortalErrorPage
      actions={
        <div className="flex flex-wrap items-center justify-center gap-2">
          <Button onClick={() => window.location.reload()} size="default">
            <PortalIcon data-icon="inline-start" name="refresh" />
            {t('admin.error.actions.reload')}
          </Button>
          <HomeButton variant="outline" />
        </div>
      }
      brand={t('admin.error.brand')}
      description={t('admin.error.system.description')}
      status="error"
      title={t('admin.error.system.title')}
    />
  );
}
